<script>
export default {
  name: "ratingAndComment",
  props: {
    textAreaPlaceholder: String,
    textAreaGuideline: String,
    maxRating: Number,
    ratingValue: String,
    ratingError: Boolean,
    commentError: Boolean,
    ratingType: String
  },
  emits: ['starRating', 'commentRating'],
  data() {
    return {
      componentComment: ''
    }
  },
  methods: {
    resize: function (textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    updateRating: function (starValue) {
      let vm = this;
      vm.$emit('starRating', starValue);
    },
    numberingFAIcon: function (starValue) {
      let FAArray = [];

      switch (starValue) {
        case 1:
          FAArray = ['fas', '1'];
          break;
        case 2:
          FAArray = ['fas', '2'];
          break;
        case 3:
          FAArray = ['fas', '3'];
          break;
        case 4:
          FAArray = ['fas', '4'];
          break;
        case 5:
          FAArray = ['fas', '5'];
          break;
        case 6:
          FAArray = ['fas', '6'];
          break;
        case 7:
          FAArray = ['fas', '7'];
          break;
        case 8:
          FAArray = ['fas', '8'];
          break;
        case 9:
          FAArray = ['fas', '9'];
          break;
        default:
          FAArray = ['fas', 'star'];
          break;
      }
      return FAArray;
    }
  },
  computed: {
    ratingValueNumber: function () {
      let vm = this,
          ratingValuePassed;
      try {
        ratingValuePassed = parseInt(vm.ratingValue);
      } catch (parsingError) {
        ratingValuePassed = 0;
      }
      return ratingValuePassed;
    }
  },
  watch: {
    componentComment: {
      handler(newValue) {
        let vm = this;
        vm.$emit('commentRating', newValue);
      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="columns is-mobile is-multiline is-mobile is-vcentered">
    <div class="column is-one-quarter">
      <div class="has-text-left" v-if="ratingType==='rating'">Rating:</div>
      <div class="has-text-left" v-if="ratingType==='scoring'">Scoring:</div>
    </div>
    <div class="column is-three-quarters has-text-justified">
      <div class="star-wrapper star-gap" v-if="ratingType==='rating'"
           v-bind:class="{'error-input':ratingError}">
        <span v-for="star in maxRating" v-bind:key="star" class="star" v-bind:class="{filled: star <= ratingValue }"
              v-on:click="updateRating(star)">
          <font-awesome-icon :icon="['fas', 'star']"/>
        </span>
      </div>
      <div class="star-wrapper score-gap" v-if="ratingType==='scoring'"
           v-bind:class="{'error-input':ratingError}">
        <span v-for="score in maxRating" v-bind:key="score" class="star" v-bind:class="{filled: score === ratingValue }"
              v-on:click="updateRating(score)">
          <font-awesome-icon :icon="numberingFAIcon(score)" size="2xl"/>
        </span>
      </div>
    </div>

    <div class="column is-full has-text-justified" v-if="textAreaGuideline.length>0">{{ textAreaGuideline }}</div>
    <div class="column is-full">
      <textarea class="textarea" v-bind:placeholder="textAreaPlaceholder"
                v-bind:class="{'error-input':commentError}"
                v-on:keyup="resize('commentArea')"
                ref="commentArea"
                v-model.trim="componentComment"></textarea>
    </div>
  </div>
</template>

<style scoped>

.error-input {
  border: 1px solid red !important;
  background-color: #ffefef !important;
}

.star-wrapper {
  display: flex;
  align-items: center;
  width: max-content;
  padding: 3px 20px;
}

.star-gap {
  gap: 10px;
}

.score-gap {
  gap: 50px;
}

.star {
  cursor: pointer;
  color: #d8d8d8;
}

.star:hover,
.star:active,
.star.filled {
  color: orange;
}
</style>